import { Button, Stack, Typography } from "@mui/material"
import { Frame } from "../../components/layouts/Frame"
import { DataTable } from "../../components/global/Table/DataTable"
import { Link } from "../../components/global/Link";
import { EditIcon } from "../../assets/svgs/EditIcon";
import { CubsIcon } from "../../assets/svgs/CubsIcon";
import { Route, Routes, useNavigate } from "react-router-dom";
import { AddProduct } from "./AddProduct";
import { EditProduct } from "./EditProduct";
import { DataTableHeadCellData } from "../../components/global/Table/DataTableHeader";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../assets/contexts/AuthContext";
import { useAPI } from "../../hooks/useAPI";
import { CategoryData, ProductData } from "../../types";

const headCells: DataTableHeadCellData[] = [
  {
    id: 'name',
    disablePadding: true,
    label: 'Name',
    align: 'left',
    sortable: true,
  },
  {
    id: 'sku',
    disablePadding: true,
    label: 'SKU',
    align: 'left',
    cellAlign: 'left',
    sortable: true,
  },
  {
    id: 'category',
    disablePadding: true,
    label: 'Category',
    align: 'left',
    cellAlign: 'left',
    sortable: true,
  },
  {
    id: 'edit',
    disablePadding: false,
    label: 'Edit',
    width: '50px',
  },
];

interface ProductsTableData {
  id: any;
  name: any;
  sku: any;
  category: any;
  edit: JSX.Element;
}

export const Products = () => {
  const navigate = useNavigate();
  const isLoading = useRef(false);
  const [sIsLoading, setSIsLoading] = useState(false);
  const { isAuthenticated } = useAuth();
  const { fetchData } = useAPI();
  const [rows, setRows] = useState<ProductsTableData[]>([]);
  const [categories, setCategories] = useState<CategoryData[]>([]);
  const [products, setProducts] = useState<ProductData[]>([]);

  const onAddProduct = () => {
    navigate('/products/create');
  }

  const onBulkDelete = async (ids: number[]) => {
    await fetchData('/products/delete',  { id: ids }, 'POST');
    refetchProducts();
  }

  const refetchProducts = async () => {
    setSIsLoading(true);
    isLoading.current = true;
    const {errors, data} = await fetchData('/products/all');
    setProducts(data ?? []);
    isLoading.current = false;
    setSIsLoading(false);
  }

  const refetchCategories = async () => {
    const {errors, data} = await fetchData('/categories/all');
    setCategories(data ?? []);
  }

  const getRows = (products: ProductData[]) => {
    const result: ProductsTableData[] = [];
    for (let i=0; i<products.length; i++) {
      result.push({
        id: `${products[i].id}`,
        name: <Typography>{products[i].name}</Typography>,
        sku: <Typography>{products[i].sku}</Typography>,
        category: <Typography>{products[i].category?.name}</Typography>,
        edit: <Link to={`/products/${products[i].id}`}><EditIcon /></Link>
      });
    }
    return result;
  }

  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      refetchProducts();
      refetchCategories();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    setRows(getRows(products ?? []));
  }, [products, categories]);

  return (
    <Frame title="Product SKUs" toolbarButtons={(
      <>
        <Button variant="contained" onClick={onAddProduct} startIcon={<CubsIcon color="#FFFFFF" />}>
          Add Product SKU
        </Button>
      </>
    )}>
      <Stack>
        <Routes>
          <Route
            path="/create/"
            element={<AddProduct refetchProducts={refetchProducts} categories={categories} />}
          ></Route>
          <Route
            path="/:product_id/"
            element={<EditProduct refetchProducts={refetchProducts} categories={categories} />}
          ></Route>
        </Routes>
        <DataTable headCells={headCells} rows={rows} onBulkDelete={onBulkDelete} isLoading={sIsLoading} title="Prouct SKUs" />
      </Stack>
    </Frame>
  )
}
